import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { refresh } from '../../services/auth.service';
import Spinner from '../../components/layout/Spinner';
import FadeIn from '../../utils/fadein';
import { FaEllipsisV, FaTimes } from 'react-icons/fa';
import { getPointActivity, createPointActivity, updatePointActivity, getPointBonusCodes, createPointBonusCode, updatePointBonusCode } from '../../utils/api/admin';
import './PointActivity.css';
import ScrollToTop from '../../components/layout/ScrollToTop';

function PointBonusCodes() {
  const [loaded, setLoaded] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [pageBreakdown, setPageBreakdown] = useState([]);
  const [data, setData] = useState([]);
  const [showSaveBanner, setShowSaveBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [pointsEarned, setPointsEarned] = useState('');
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [editName, setEditName] = useState('');
  const [editDescription, setEditDescription] = useState('');
  const [editCode, setEditCode] = useState('');
  const [editPointsEarned, setEditPointsEarned] = useState('');
  const [editSelectedId, setEditSelectedId] = useState(null);
  const [costPerCredit, setCostPerCredit] = useState(.25);
  const [totalPoints, setTotalPoints] = useState(0);
  const [pointActivity, setPointActivity] = useState([]);
  const [code, setCode] = useState('');
  const [selectedActivityId, setSelectedActivityId] = useState(null);
  const [editSelectedActivityId, setEditSelectedActivityId] = useState(null); 
  const imageUrl = process.env.REACT_APP_IMAGE_URL;
  const baseImageUrl = process.env.REACT_APP_BASE_IMAGE_URL;
  const screenshotUrl = process.env.REACT_APP_BASE_IMAGE_URL + 'companyscreenshots/';

  async function loadData(){
    let res = await getPointBonusCodes();

    if (res.success){
      setData(res.data);
      setLoaded(true);
    }
  }

  useEffect(() => {
    async function fetchActivity(){
      let res = await getPointActivity();

      if (res.success){
        setPointActivity(res.data);
      }
    }

    async function loadData(){
      let res = await getPointBonusCodes();

      if (res.success){
        setData(res.data);
        setLoaded(true);
      }
    }

    fetchActivity();
    loadData();
  }, []);

  async function handleCreate(){
    if (!name || !code){
      alert("Please fill in all fields");
      return;
    }

    let res = await createPointBonusCode(name, code, 0, 'Active', selectedActivityId);

    if (res.success){
      loadData();

      setName('');
      setCode('');
      setPointsEarned('');
    }
  }

  function loadSaveBanner(){
    setShowSaveBanner(true);
    const timer = setTimeout(() => {
      setShowSaveBanner(false);
    }, 3000);
    return () => clearTimeout(timer);
  }

  async function handleEdit(id, item){
    setSelectedId(id);
    setEditName(item.name);
    setEditDescription(item.description);
    setEditCode(item.code);
    setEditPointsEarned(item.points_earned);
    setEditSelectedActivityId(item.point_activity_id);
    setShowEdit(true);
  }

  async function handleUpdate(){
    let res = await updatePointBonusCode(selectedId, editName, editCode, editPointsEarned, 'Active', editSelectedActivityId);

    if (res.success){
      setShowEdit(false);
      loadData();
    }

    else{
      alert("Update failed");
    }
  }

  return (
    <>
      <ScrollToTop />
      <Helmet>
        <title>LeadrPro - Discover new software</title>
      </Helmet>

      <h1>Point Bonus Codes</h1>

      <p className='mt-10 mb-10'>
        <strong>Point Bonus Codes allow you to reward users with points for specific actions.</strong>
      </p>


      <div className='mt-10'>
        <span className='btn' onClick={() => setShowAdd(!showAdd)}>+ Add Code</span>
      </div>

      {showAdd && (
      <div className='admindashboard__form'>
        <div>
          <label>Name</label>
          <div>
            <input type='text' placeholder='' className='input' value={name} onChange={(e) => setName(e.target.value)} />
          </div>
        </div>

        <div>
          <label>Code</label>
          <div>
            <input type='text' placeholder='' className='input' value={code} onChange={(e) => setCode(e.target.value)} />
          </div>
        </div>

        <div className='mt-10'>
          <label>Point Activity</label>

          <div>
            <select value={selectedActivityId} onChange={(e) => setSelectedActivityId(e.target.value)}>
              <option value=''>Select Activity</option>
              {pointActivity.filter(x => x.type == 'Signup bonus').map((activity) => (
                <option key={activity.point_activity_id} value={activity.point_activity_id}>
                  {activity.name} - {activity.points_earned} Points
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className='mt-20'>
          <button className='btn' onClick={() => handleCreate()}>Add Code</button>
        </div>
      </div>
      )}

      {loaded===false && (
        <Spinner />
      )}

      {loaded && (
         <div>
          <table className='admindashboard__table table'>
            <tr>
              <th>Name</th>
              <th>Code</th>
              <th>Points Earned</th>
              <th>Status</th>
              <th>Uses</th>
              <th></th>
            </tr>

            {data.map((item, index) => (
              <tr key={index}>
                <td>
                  {item.name}
                </td>

                <td>
                  {item.code}
                </td>

                <td>
                  <div>
                    {item.point_activity_name}
                  </div>
                  +{item.points_earned} points == {item.points_earned * .25} USD
                </td>

                <td>
                  {item.status === 'Active' ? (
                    <span className='text-green-500'>Active</span>
                  ) : (
                    <span className='text-red-500'>Inactive</span>
                  )}
                </td>

                <td>
                  {item.use_count}
                </td>

                <td>
                  <button className='btn' onClick={() => handleEdit(item.point_bonus_code_id, item)}>Edit</button>
                </td>
              </tr>
            ))}
          </table>
       </div>
      )}

    {showEdit && (
        <>
          <div className='overlay'></div>
          <div className='modal'>
            <div className='modal__close' onClick={() => setShowEdit(false)}>
              <FaTimes />
            </div>

            <h2 className='modal__h2'>Edit</h2>

            <div className='mt-10'>
              <div>
                <label>Name</label>
                <input type='text' className='input' value={editName} onChange={(e) => setEditName(e.target.value)}></input>
              </div>

              <div>
                <label>Code</label>

                <textarea className='input textarea' value={editCode} onChange={(e) => setEditCode(e.target.value)}></textarea>
              </div>

              <div>
                <label>Point Activity</label>
                
                <select value={editSelectedActivityId} onChange={(e) => setEditSelectedActivityId(e.target.value)}>
                  <option value=''>Select Activity</option>
                  {pointActivity.map((activity) => (
                    <option key={activity.point_activity_id} value={activity.point_activity_id}>
                      {activity.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className='mt-20'>
                <button className='btn' onClick={() => handleUpdate()}>Update</button>
              </div>
            </div>
          </div>
        </>
      )}

      {showSaveBanner && (
        <FadeIn delay={150} duration={300}>
          <div className='profileinfo__saved-banner'>
            Profile updated successfully!
          </div>
        </FadeIn>
      )}
    </>
  );
}

export default PointBonusCodes;